export default __webpack_public_path__ + "fonts/form_1.908f3a75a74f634192e863e7a1223e6c.png";